import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";

function Form3({ permit_id, permit_type_id, fetchComplitionSatusData }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    id: "",
    residual_hazards: [],
    ppe_precautions: [],
    precaution_description: "",
  });

  const hazardOptions = [
    "Lack of Oxygen/H₂S",
    "Toxic Gases",
    "Combustible Cases",
    "Pyrophoric Iron",
    "Corrosive Chemicals",
    "Steam-Condensable",
    "Others",
  ];

  const ppeOptions = [
    "Face Shield",
    "Apron",
    "Goggles",
    "Dust Respirator",
    "Fresh Air Mask",
    "Life Line",
    "Safety Belt (Full body harness)",
    "Airline",
    "Earmuff",
  ];

  const handleCheckboxChange = (field, value) => {
    const current = formData[field] || [];
    const updated = current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value];
    setFormData((prev) => ({ ...prev, [field]: updated }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancelClick = () => {
    navigate("/cold-work-permit");
  };

  useEffect(() => {
    const fetchHazardPrecaution = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(
          `${API_URL}/api/get_hazard_precautions?permit_id=${permit_id}`,
          { headers: { Authorization: authKey } }
        );
        const hazardPrecaution = response.data.hazard_precautions?.[0];
        if (hazardPrecaution) {
          setFormData({
            id: hazardPrecaution.id || "",
            residual_hazards: hazardPrecaution.residual_hazards || [],
            ppe_precautions: hazardPrecaution.ppe_precautions || [],
            precaution_description:
              hazardPrecaution.precaution_description || "",
          });
        }
      } catch (error) {
        console.error("Error fetching hazard precautions:", error);
      }
    };
    fetchHazardPrecaution();
  }, [permit_id]);

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const handleSaveClick = async () => {
    setIsLoading(true);
    try {
      const authKey = localStorage.getItem("authKey");
      const payload = {
        permit_id: permit_id,
        id: formData.id || undefined,
        residual_hazards: formData.residual_hazards,
        ppe_precautions: formData.ppe_precautions,
        precaution_description: formData.precaution_description,
      };

      let response;
      if (formData.id) {
        response = await axios.put(
          `${API_URL}/api/update_hazard_precaution`,
          payload,
          { headers: { Authorization: authKey } }
        );
      } else {
        response = await axios.post(
          `${API_URL}/api/add_hazard_precaution`,
          { ...payload, work_permit_id: id },
          { headers: { Authorization: authKey } }
        );
      }

      if (response.status === 200) {
        showSnackbar(
          formData.id ? "Updated successfully!" : "Added successfully!"
        );
        setSeverity("success");
        await review_submit();
        setTimeout(() => navigate("/cold-work-permit"), 3000);
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      console.error("Save error:", error);
      setSeverity("error");
      showSnackbar("Failed to save hazard precaution");
    } finally {
      setIsLoading(false);
    }
  };

   const review_submit = async () => {
    try {
      const authKey = localStorage.getItem("authKey"); 

      const submitPayload = {
        permit_id: permit_id,
        request_type: "new",
      };

      const submitResponse = await axios.put(
        `${API_URL}/api/v2/issuer/submit_for_review`,
        submitPayload,
        { headers: { Authorization: authKey } }
      );

      if (submitResponse.status !== 200) {
        throw new Error(
          submitResponse.data.message || "Failed to submit for review"
        );
      }
    } catch (error) {
      console.error("Save error:", error);
      // setSeverity("error");
      // showSnackbar(error.message || "Failed to save data");
    } finally {
    }
  };

  // const handleSaveClick = async () => {
  //   setIsLoading(true);

  //   try {
  //     const authKey = localStorage.getItem("authKey");

  //     // -------------------------------
  //     // 1️⃣ FIRST API — Add/Update Hazard Precautions
  //     // -------------------------------
  //     const payload = {
  //       permit_id: permit_id,
  //       id: formData.id || undefined,
  //       residual_hazards: formData.residual_hazards,
  //       ppe_precautions: formData.ppe_precautions,
  //       precaution_description: formData.precaution_description,
  //     };

  //     let response;
  //     if (formData.id) {
  //       // UPDATE
  //       response = await axios.put(
  //         `${API_URL}/api/update_hazard_precaution`,
  //         payload,
  //         { headers: { Authorization: authKey } }
  //       );
  //     } else {
  //       // INSERT
  //       response = await axios.post(
  //         `${API_URL}/api/add_hazard_precaution`,
  //         { ...payload, work_permit_id: id },
  //         { headers: { Authorization: authKey } }
  //       );
  //     }

  //     if (response.status !== 200) {
  //       throw new Error(response.data.message || "Failed to save hazards");
  //     }

  //     // -------------------------------
  //     // 2️⃣ SECOND API — Submit for Review (Issuer)
  //     // -------------------------------
  //     const submitPayload = {
  //       permit_id: permit_id,
  //       request_type: "new",
  //     };

  //     const submitResponse = await axios.put(
  //       `${API_URL}/api/v2/issuer/submit_for_review`,
  //       submitPayload,
  //       { headers: { Authorization: authKey } }
  //     );

  //     if (submitResponse.status !== 200) {
  //       throw new Error(
  //         submitResponse.data.message || "Failed to submit for review"
  //       );
  //     }

  //     // -------------------------------
  //     // 3️⃣ FINAL SUCCESS
  //     // -------------------------------
  //     setSeverity("success");
  //     showSnackbar(
  //       formData.id
  //         ? "Updated successfully & submitted for review!"
  //         : "Added successfully & submitted for review!"
  //     );

  //     setTimeout(() => navigate("/cold-work-permit"), 1200);
  //   } catch (error) {
  //     console.error("Save error:", error);
  //     setSeverity("error");
  //     showSnackbar(error.message || "Failed to save data");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <div className="data-form-content">
      {/* Internal CSS */}
      <style>{`
        .form-row {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
           justify-content: space-between;
        }

        .card {
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

       .checkbox-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  min-width: 150px;
}

        .form-group textarea {
          width: 100%;
          padding: 8px;
          font-size: 14px;
          resize: vertical;
          border: 1px solid #ccc;
          border-radius: 5px;
        }

        .button-group {
          display: flex;
          gap: 10px;
          margin-top: 20px;
        }

        .data-form-save-button,
        .data-form-cancel-button {
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .data-form-save-button {
          background-color: #1976d2;
          color: white;
        }

        .data-form-cancel-button {
          background-color: #ccc;
        }

        .half-width {
  flex: 0 0 45%;
  display: flex;
  flex-direction: column;
}

.full-width {
  flex: 1 1 100%;
}

        @media (max-width: 768px) {
          .half-width {
            flex: 1 1 100%;
          }
        }
      `}</style>

      <div className="data-form-header">
        <div className="data-form-header-content">
          <PageBackTitle className="data-form-heading-content-left-side">New Work Permit</PageBackTitle>
        </div>
      </div>
      <div className="header-separator"></div>

      <div className="data-form-body">
        <form className="form-detail">
          <div className="form-row">
            {/* Residual Hazards Card */}
            <div className="half-width card">
              <h3 className="section-title">Residual Hazards</h3>
              <p>Select all that apply:</p>
              <div className="checkbox-group">
                {hazardOptions.map((option) => (
                  <label key={option} className="checkbox-item">
                    <input
                      type="checkbox"
                      checked={formData.residual_hazards.includes(option)}
                      onChange={() =>
                        handleCheckboxChange("residual_hazards", option)
                      }
                    />{" "}
                    {option}
                  </label>
                ))}
              </div>
            </div>

            {/* PPE Precautions Card */}
            <div className="half-width card">
              <h3 className="section-title">PPE Precautions</h3>
              <p>Select additional PPEs:</p>
              <div className="checkbox-group">
                {ppeOptions.map((option) => (
                  <label key={option} className="checkbox-item">
                    <input
                      type="checkbox"
                      checked={formData.ppe_precautions.includes(option)}
                      onChange={() =>
                        handleCheckboxChange("ppe_precautions", option)
                      }
                    />{" "}
                    {option}
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Additional Precaution */}
          <div className="form-row">
            <div className="form-group full-width">
              <label htmlFor="precaution_description">
                Additional Precaution
              </label>
              <textarea
                name="precaution_description"
                rows={4}
                placeholder="Describe any additional precaution"
                value={formData.precaution_description}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </form>
      </div>

      <div className="footer">
        <div className="button-group">
          <button
            className="data-form-save-button"
            // type="button"
            onClick={handleSaveClick}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </button>
          <button
            className="data-form-cancel-button"
            onClick={handleCancelClick}
          >
            Cancel
          </button>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default Form3;
